import { DashboardLayout } from "@/components";
import { authMiddleware } from "@/middleware";
import { BuyerRelationsPage } from "@/pages/relations";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_market/relations/buyer")({
	component: () => (
		<DashboardLayout>
			<BuyerRelationsPage />
		</DashboardLayout>
	),
	loader: authMiddleware,
});
